export default __webpack_public_path__ + "static/media/pg-icon.fcdcf654.webp";